module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "chpt"
  }, [_c('a', {
    attrs: {
      "id": "page_31"
    }
  }), _c('span', {
    staticClass: "textStyle4"
  }, [_vm._v("CHAPTER")]), _c('br'), _c('span', {
    staticClass: "textStyle8"
  }, [_vm._v("3")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "textStyle9"
  }, [_vm._v("T")]), _c('span', {
    staticClass: "textStyle10"
  }, [_vm._v("he daylight had gone, but the night was not yet cold and the streets were filled with people. Denton, able to see over the heads of most of them, looked around for signs, familiar names, but found none. The streets were dark, the only light what spilled from windows and doorways and the candles of the little shrines that stood at every corner, set into niches in the buildings. If there were street signs in deepest Spagnuoli, he didn’t know where to look for them. He was trying to hurry through whatever nonsense the old man in the monk’s robe had in store for him—get it over with and take Janet to supper and then to bed, lose himself in her, try to find in her some still place where there were no books to be written, no houses to be found.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle12"
  }, [_vm._v("‘Il vecchio catedrale?’")]), _vm._v(" "), _c('span', {
    staticClass: "textStyle10"
  }, [_vm._v("he said to a pretty girl.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle12"
  }, [_vm._v("‘Sinistra, sinistra.’")]), _vm._v(" "), _c('span', {
    staticClass: "textStyle10"
  }, [_vm._v("She laughed at him. Because of his accent? His hat? His height? More of the traveller’s curse.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_32"
    }
  }), _c('span', {
    staticClass: "textStyle12"
  }, [_vm._v("Left, left.")]), _vm._v(" "), _c('span', {
    staticClass: "textStyle10"
  }, [_vm._v("He turned left at the next corner, sending the candles below a Virgin dancing, hoping the girl hadn’t been playing a Sophie-like joke on him, then left into an alley no wider than his outstretched arms. No, a bit wider than that; he tried it and found that he had to hold his hat in one hand so the brim would just touch the wall. Still, a very narrow little way. Buildings rose solidly on both sides, but doors were open at ground level and light spilled out. Inside, families stared out at him from several steps below street level: people eating, children and a man in shirtsleeves at a table, one or two women stopping in the serving, too. Everybody round eyed, as if he had been long awaited and was feared. He tried smiling and speaking and got no answer.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle10"
  }, [_vm._v("A hundred feet, a hundred and fifty feet along, a ruined church spired up on his right. Light from an open doorway showed him rotted stone, carving reduced to rounded bulges, closed double doors.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle12"
  }, [_vm._v("‘Il vecchio catedrale?’")]), _vm._v(" "), _c('span', {
    staticClass: "textStyle10"
  }, [_vm._v("he said to a man coming towards him. The man looked like all the others he had seen in Spagnuoli because of the darkness.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle10"
  }, [_vm._v("The man said something but Denton couldn’t follow it. Somebody else squeezed behind the man, somebody younger, one of the young toughs of these alleys, perhaps. The man pointed, turned away, headed wherever he was going.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle12"
  }, [_vm._v("To the right.")]), _vm._v(" "), _c('span', {
    staticClass: "textStyle10"
  }, [_vm._v("Denton muttered")]), _vm._v(" "), _c('span', {
    staticClass: "textStyle12"
  }, [_vm._v("Grazie, mille grazie,")]), _vm._v(" "), _c('span', {
    staticClass: "textStyle10"
  }, [_vm._v("backed away into the darkness. Why did he feel obligated to politeness, to this spreading of the hands as if embarrassed? A lot of it was language, language he didn’t understand and language he couldn’t use to explain himself. Some of it was his old guilt over having enough money to be here in this suit and this hat among people who lived in one room and looked out at him as if he were a myth come calling.")]), _vm._v(" "), _c('span', {
    staticClass: "textStyle12"
  }, [_vm._v("Have to get some different clothes.")]), _vm._v(" "), _c('span', {
    staticClass: "textStyle12"
  }, [_vm._v("Look like the locals.")]), _vm._v(" "), _c('span', {
    staticClass: "textStyle10"
  }, [_vm._v("But he could never change his size.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle12"
  }, [_vm._v("To the right.")]), _vm._v(" "), _c('span', {
    staticClass: "textStyle10"
  }, [_vm._v("There was the ‘old cathedral’, surely, then a pair of huge wooden doors, opened inward at an angle, beyond them a courtyard that must once have allowed a carriage to turn around. Galleries rose four storeys high, light spilling from open doors at every level. Voices trilled down like falling coins, raucous ones and treble ones, laughter and shouting and murmurs, a child weeping. A slap. The smell of twenty suppers mingling, onions recognisable, wine, coffee.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_33"
    }
  }), _c('span', {
    staticClass: "textStyle12"
  }, [_vm._v("‘Eh!’")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle10"
  }, [_vm._v("The voice came from within the double doors. His eyes adjusted; he saw a door within the right-hand door, a pedestrian door for when the great ones were closed at night. The little door was open and a small man stood in it. Denton thought that the man could easily have come around the big door, but he had chosen to half conceal himself in the little one.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle12"
  }, [_vm._v("‘La pioggia no’ continua,’")]), _vm._v(" "), _c('span', {
    staticClass: "textStyle10"
  }, [_vm._v("the man said. The rain has stopped. As indeed it had. Denton agreed that the rain had stopped and said he was looking for Fra Geraldo.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle12"
  }, [_vm._v("‘Eh, Fra Geraldo!’")]), _vm._v(" "), _c('span', {
    staticClass: "textStyle10"
  }, [_vm._v("Fra Geraldo seemed to depress the man. Denton went still closer, took a side step so that the light from behind him would spill over the other man. What he could now see of him was not impressive: a hunched body, thin hair that looked surprisingly light coloured for a Neapolitan’s, a rat’s face.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle12"
  }, [_vm._v("‘Cerco Fra Geraldo. Palazzo Minerva.’")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle12"
  }, [_vm._v("‘Si, si, Palazzo Minerva. D’accordo, Palazzo Minerva.’")]), _vm._v(" "), _c('span', {
    staticClass: "textStyle10"
  }, [_vm._v("The man disappeared, reappeared immediately around the big door. He gestured for Denton to follow, then stood looking into the courtyard, shoulders rounded, as if the thought of crossing it—it couldn’t be more than fifty feet deep, Denton thought—was too much for him. At last, he sighed mightily and set out, fetching up on the far side at a doorway that had once been magnificently carved and looked now like wet sugar. Even in the bad light, Denton could see the remains of a heraldic shield, the hindquarters of some sort of animal, several heads without noses. A crudely painted board had been hung from a couple of the heads:")]), _vm._v(" "), _c('span', {
    staticClass: "textStyle12"
  }, [_vm._v("Fratelli di Santo Simeone Stilites.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle12"
  }, [_vm._v("‘Palazzo Minerva,’")]), _vm._v(" "), _c('span', {
    staticClass: "textStyle10"
  }, [_vm._v("Denton’s guide said. He sighed again, then hit an arched wooden door with the side of his left fist. The noise was thunderous, but nobody in the courtyard seemed to notice. The thunder went on—four, five, six blows. The man tapped his right ear.")]), _vm._v(" "), _c('span', {
    staticClass: "textStyle12"
  }, [_vm._v("‘Sordo.’")]), _vm._v(" "), _c('span', {
    staticClass: "textStyle10"
  }, [_vm._v("Deaf. Denton hadn’t thought Fra Geraldo deaf at all. Maybe deaf when he wanted to be.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_34"
    }
  }), _c('span', {
    staticClass: "textStyle10"
  }, [_vm._v("They stood looking at the door for perhaps thirty seconds. The small man shrugged.")]), _vm._v(" "), _c('span', {
    staticClass: "textStyle12"
  }, [_vm._v("‘Non c’e.’")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle10"
  }, [_vm._v("Denton had prepared his next speech with a dictionary before he had left the pension.")]), _vm._v(" "), _c('span', {
    staticClass: "textStyle12"
  }, [_vm._v("‘O fatto un appuntamento per le otto.’")]), _vm._v(" "), _c('span', {
    staticClass: "textStyle10"
  }, [_vm._v("I made an appointment for eight.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle12"
  }, [_vm._v("‘Eh. Lui dicii. Un americano, dicii, molto grande.’")]), _vm._v(" "), _c('span', {
    staticClass: "textStyle10"
  }, [_vm._v("Denton got most of it—the Fra had apparently told the doorkeeper that a big American was coming.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle10"
  }, [_vm._v("The man nodded sadly as if it were the inevitable fate of appointments to go wrong, a shrug and a glance at the door suggesting that Fra Geraldo was not to be trusted. Still, he hit the door again with the side of his fist, the noise astonishing.")]), _vm._v(" "), _c('span', {
    staticClass: "textStyle12"
  }, [_vm._v("Fit to wake the dead")]), _c('span', {
    staticClass: "textStyle10"
  }, [_vm._v(", Denton thought.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle10"
  }, [_vm._v("Denton looked around the courtyard as if Fra Geraldo might appear there, but there were only the lights spilling from doorways, the flitting passage of children running in the darkness. Something smelled delicious. He remembered he was missing his supper; there was some consolation in knowing it wouldn’t have been as good as what he was smelling—the pension made much ado of its authentically English food, which the other guests seemed to like.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle10"
  }, [_vm._v("Denton turned back to his guide.")]), _vm._v(" "), _c('span', {
    staticClass: "textStyle12"
  }, [_vm._v("‘Alora…’")]), _vm._v(" "), _c('span', {
    staticClass: "textStyle10"
  }, [_vm._v("The all-purpose word, like ‘well’.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle12"
  }, [_vm._v("‘Aspet’, aspet’—’")]), _vm._v(" "), _c('span', {
    staticClass: "textStyle10"
  }, [_vm._v("His face, half in darkness, was trying to look either pathetic or sly, Denton couldn’t tell which.")]), _vm._v(" "), _c('span', {
    staticClass: "textStyle12"
  }, [_vm._v("‘Sono il portiere. O le chiave…’")]), _vm._v(" "), _c('span', {
    staticClass: "textStyle10"
  }, [_vm._v("He jangled a bunch of oversized keys as if to suggest that he could use them if he had a reason to.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle10"
  }, [_vm._v("Denton figured that this was a time to offer money. He produced a coin, handed it over. The")]), _vm._v(" "), _c('span', {
    staticClass: "textStyle12"
  }, [_vm._v("portiere")]), _vm._v(" "), _c('span', {
    staticClass: "textStyle10"
  }, [_vm._v("shuffled closer to the door. He muttered again, something about Fra Geraldo and deafness. The key clattered in the lock and the door swung open a few inches and stuck against the stone floor. The")]), _vm._v(" "), _c('span', {
    staticClass: "textStyle12"
  }, [_vm._v("portiere")]), _vm._v(" "), _c('span', {
    staticClass: "textStyle10"
  }, [_vm._v("put his scrawny shoulder to it and pushed, and the door scraped and groaned inward. He muttered something about")]), _vm._v(" "), _c('span', {
    staticClass: "textStyle12"
  }, [_vm._v("sempre")]), _c('span', {
    staticClass: "textStyle10"
  }, [_vm._v(",")]), _vm._v(" "), _c('span', {
    staticClass: "textStyle10"
  }, [_vm._v("always, and gave up when there was just enough space for them to squeeze through.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_35"
    }
  }), _c('span', {
    staticClass: "textStyle10"
  }, [_vm._v("‘Fra Geraldo! Fra Gera-a-a-ldo!’")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle10"
  }, [_vm._v("A candle burned in a candlestick on a table against a wall. Otherwise, the space beyond the door was in darkness. Denton got no hint of size or shape or colour. A smell, mostly damp, as if they had entered a cellar, asserted itself.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle10"
  }, [_vm._v("‘Hello! Fra Geraldo? It’s Mr Denton!’")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle12"
  }, [_vm._v("‘Personna.’")]), _vm._v(" "), _c('span', {
    staticClass: "textStyle10"
  }, [_vm._v("The")]), _vm._v(" "), _c('span', {
    staticClass: "textStyle12"
  }, [_vm._v("portiere")]), _vm._v(" "), _c('span', {
    staticClass: "textStyle10"
  }, [_vm._v("hung back in the doorway. He rattled off something that Denton didn’t catch, a gesture seeming to suggest that he was talking about getting out of there. Instead, Denton took out his electric flash-light (so called because it gave only a few seconds of light at a time) and shone it about, catching dull brown walls, a beamed ceiling overhead. His nostrils widened as he encountered another smell: cooking. Fish, unquestionably fish.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle10"
  }, [_vm._v("‘Maybe,’ he said in his limping Italian, ‘maybe—eating.’ He knew he hadn’t got it right, but close enough. He raised his voice. ‘Fra Geraldo?’")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle10"
  }, [_vm._v("Ahead another fifteen feet was a second door, less massive but sturdy, also panelled. Oak. He went to it and pounded. Behind him the")]), _vm._v(" "), _c('span', {
    staticClass: "textStyle12"
  }, [_vm._v("portiere")]), _vm._v(" "), _c('span', {
    staticClass: "textStyle10"
  }, [_vm._v("shuffled partway in, now speaking incomprehensible words whose tone was perfectly clear: You’re going to get me into trouble and my supper’s getting cold.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle10"
  }, [_vm._v("Denton opened the door.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle10"
  }, [_vm._v("Beyond was a bigger space that vanished overhead in more darkness. To right and left, he had a sense of architectural bits picked out very dimly—a door frame, the edge of a panel—but he was focused on what lay ahead and was better lighted. A staircase ran up the wall to his left and then took a turn to the right and went up again; a massive oak newel stood at the bottom, its carved shape replicated in the spindles that marched up under an oak banister almost a foot broad. Two gaslights flared against the wall above the stairway. It was not, however, the architecture of the")]), _vm._v(" "), _c('span', {
    staticClass: "textStyle12"
  }, [_vm._v("Seicento")]), _vm._v(" "), _c('span', {
    staticClass: "textStyle10"
  }, [_vm._v("that held his eye.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_36"
    }
  }), _c('span', {
    staticClass: "textStyle10"
  }, [_vm._v("A figure was sprawled on its back over the three lowest steps. One arm was flung up the stairs as if pointing or appealing for help in that direction; the legs were splayed; the head was rolled almost to its left shoulder, held only by the edge of the stair, it seemed, from rolling the rest of the way by itself.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle10"
  }, [_vm._v("The figure was nude from the waist down.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle10"
  }, [_vm._v("Denton knew it was the old man before he ever got to it. He could smell him; he could see the wrinkles in the skin of the thin old arms, the sagging leg muscles; he recognised the childlike face, even with its mouth open and its eyes bulging.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle12"
  }, [_vm._v("‘O Dio!’")]), _vm._v(" "), _c('span', {
    staticClass: "textStyle10"
  }, [_vm._v("the")]), _vm._v(" "), _c('span', {
    staticClass: "textStyle12"
  }, [_vm._v("portiere")]), _vm._v(" "), _c('span', {
    staticClass: "textStyle10"
  }, [_vm._v("whispered.")]), _vm._v(" "), _c('span', {
    staticClass: "textStyle12"
  }, [_vm._v("‘E lui?’")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle10"
  }, [_vm._v("But Denton was shining his flash-light on the old man’s crotch, where there was nothing male except a thin tuft of grey hair. Denton’s first shocked thought had been that the body was a woman’s: the deep shadow between the skinny thighs was relieved by nothing to reflect the gaslight. He moved his own light and saw, however, a stump of tissue, below it an old and puckered scar that ran to the pubic synthesis. Some time long ago, Fra Geraldo had had both his penis and his testicles cut off.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle10"
  }, [_vm._v("The")]), _vm._v(" "), _c('span', {
    staticClass: "textStyle12"
  }, [_vm._v("portiere")]), _vm._v(" "), _c('span', {
    staticClass: "textStyle10"
  }, [_vm._v("looked down where Denton’s light was shining.")]), _vm._v(" "), _c('span', {
    staticClass: "textStyle12"
  }, [_vm._v("‘O Dio,’")]), _vm._v(" "), _c('span', {
    staticClass: "textStyle10"
  }, [_vm._v("he whispered,")]), _vm._v(" "), _c('span', {
    staticClass: "textStyle12"
  }, [_vm._v("‘no cazzo,’")]), _vm._v(" "), _c('span', {
    staticClass: "textStyle10"
  }, [_vm._v("and with a sigh he fainted. No cock.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle10"
  }, [_vm._v("Denton pulled him away from the old man, one of whose feet had cushioned the")]), _vm._v(" "), _c('span', {
    staticClass: "textStyle12"
  }, [_vm._v("portiere")]), _c('span', {
    staticClass: "textStyle10"
  }, [_vm._v("’s fall; he shook him, slapped his cheeks gently, moved his arms back and forth. The eyes opened, saw nothing they recognised; then he remembered and said,")]), _vm._v(" "), _c('span', {
    staticClass: "textStyle12"
  }, [_vm._v("‘No cazzo!’")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle10"
  }, [_vm._v("‘Forget about his")]), _vm._v(" "), _c('span', {
    staticClass: "textStyle12"
  }, [_vm._v("cazzo")]), _c('span', {
    staticClass: "textStyle10"
  }, [_vm._v(".")]), _vm._v(" "), _c('span', {
    staticClass: "textStyle10"
  }, [_vm._v("Can you stand?’ He realised he was speaking English, tried to think of the Italian, gave it up, and dragged the little man to his feet.")]), _vm._v(" "), _c('span', {
    staticClass: "textStyle12"
  }, [_vm._v("‘Polizia,’")]), _vm._v(" "), _c('span', {
    staticClass: "textStyle10"
  }, [_vm._v("he said. ‘Get the")]), _vm._v(" "), _c('span', {
    staticClass: "textStyle12"
  }, [_vm._v("polizia")]), _c('span', {
    staticClass: "textStyle10"
  }, [_vm._v(".’")]), _vm._v(" "), _c('span', {
    staticClass: "textStyle10"
  }, [_vm._v("He shook him, pulled his head back when he tried to look again at the body on the stairs.")]), _vm._v(" "), _c('span', {
    staticClass: "textStyle12"
  }, [_vm._v("‘Guardie, capisce? Eh? Polizia?’")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle10"
  }, [_vm._v("The little man nodded. Denton shoved him towards the door. ‘Get the")]), _vm._v(" "), _c('span', {
    staticClass: "textStyle12"
  }, [_vm._v("polizia")]), _c('span', {
    staticClass: "textStyle10"
  }, [_vm._v(".’")]), _vm._v(" "), _c('span', {
    staticClass: "textStyle10"
  }, [_vm._v("He shoved him again and the man started to trot. After he’d gone through the door, Denton shouted, ‘And a doctor!")]), _vm._v(" "), _c('span', {
    staticClass: "textStyle12"
  }, [_vm._v("Medico! Dottore!")]), _c('span', {
    staticClass: "textStyle10"
  }, [_vm._v("’")]), _vm._v(" "), _c('span', {
    staticClass: "textStyle10"
  }, [_vm._v("Or did")]), _vm._v(" "), _c('span', {
    staticClass: "textStyle12"
  }, [_vm._v("dottore")]), _vm._v(" "), _c('span', {
    staticClass: "textStyle10"
  }, [_vm._v("mean only somebody like Inspector Gianaculo? What the hell. He shouted")]), _vm._v(" "), _c('span', {
    staticClass: "textStyle12"
  }, [_vm._v("‘Medico!’")]), _vm._v(" "), _c('span', {
    staticClass: "textStyle10"
  }, [_vm._v("again and gave it up.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_37"
    }
  }), _c('span', {
    staticClass: "textStyle10"
  }, [_vm._v("He went back to the stair. The old man’s robe had caught up under his back, leaving his legs and groin bare. Denton put his hand on the old man’s throat. There was no pulse in the neck, but the skin was warm to his touch. He looked again at the groin. The stump of the penis was visible when he held the light close, the old wound healed but looking somehow ugly and unfinished, while the scar where the testicles had been removed looked quite neat and rather unsurprising. Denton shone his light over the rest of the body, then the head. Blood had run from the nose and was still wet; a gash on the top of the bald head had bled a little and swelled very slightly, but the amount of blood seemed slight for what must have been a terrible fall.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle10"
  }, [_vm._v("Denton went up the stairs, shining his light back and forth at each step. Uncarpeted, the stairs were thick with dust except in the middle where Fra Geraldo must have gone up and down. The landing, however, twelve steps up, was clean. A twig broom lay at an angle a few steps above the body. Denton looked down at the next step below the landing, saw where dust from the landing had been swept over, probably broadcast over several of the lower steps. Had Fra Geraldo fallen while he was sweeping his stairs for his visitor?")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle10"
  }, [_vm._v("Despite the sign outside that said that this was a monastery, Denton thought the place was empty. Above, there was nothing but silence; nobody had come to their loud knocking or their calls. Was Fra Geraldo the last brother in this order? Or was the brotherhood of Saint Simeon Stylites a fiction?")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle10"
  }, [_vm._v("That Fra Geraldo might have been mad hardly surprised Denton. Upper-class Englishmen who turned up in Naples filthy and stinking weren’t likely to be entirely sane. Or was this English eccentricity?")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle10"
  }, [_vm._v("He went around the turn in the stairs and up the next half-flight to the floor above. Six steps. All had been swept. The corridor above had not. A path down the middle showed where Fra Geraldo’s skirts had done the sweeping.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_38"
    }
  }), _c('span', {
    staticClass: "textStyle10"
  }, [_vm._v("Alone? If there were any other brothers, they were deaf to the calls that Denton now made.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle10"
  }, [_vm._v("He went down again. Half a dozen men were crowded near the door, staring at the corpse. A couple of women stood behind, kerchiefs over their hair, trying to see over the men.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle10"
  }, [_vm._v("Denton put his flash-light off and stopped three steps above the body. In the silence, he said,")]), _vm._v(" "), _c('span', {
    staticClass: "textStyle12"
  }, [_vm._v("‘E morto.’")]), _vm._v(" "), _c('span', {
    staticClass: "textStyle10"
  }, [_vm._v("Not so brilliant: He’s dead.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle10"
  }, [_vm._v("The men murmured. One said something that was a question and involved the")]), _vm._v(" "), _c('span', {
    staticClass: "textStyle12"
  }, [_vm._v("cazzo")]), _c('span', {
    staticClass: "textStyle10"
  }, [_vm._v(".")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle10"
  }, [_vm._v("Denton tried to summon up words. ‘Uunnh—")]), _c('span', {
    staticClass: "textStyle12"
  }, [_vm._v("Aspetare—Aspeta—il medico. Dottore.")]), _c('span', {
    staticClass: "textStyle10"
  }, [_vm._v("’")]), _vm._v(" "), _c('span', {
    staticClass: "textStyle12"
  }, [_vm._v("Aspetare")]), _vm._v(" "), _c('span', {
    staticClass: "textStyle10"
  }, [_vm._v("meant ‘wait’, he was fairly sure of that.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle10"
  }, [_vm._v("One of the men took a step forward. He seemed to accept that Denton was in charge. He said something that started with")]), _vm._v(" "), _c('span', {
    staticClass: "textStyle12"
  }, [_vm._v("‘permesso’")]), _c('span', {
    staticClass: "textStyle10"
  }, [_vm._v(",")]), _vm._v(" "), _c('span', {
    staticClass: "textStyle10"
  }, [_vm._v("which Denton thought meant ‘permission’, and ended with a question, the man gesturing and leaning forward. Denton risked it and said, ‘No.")]), _vm._v(" "), _c('span', {
    staticClass: "textStyle12"
  }, [_vm._v("Aspetare la polizia. E il medico.")]), _c('span', {
    staticClass: "textStyle10"
  }, [_vm._v("’")]), _vm._v(" "), _c('span', {
    staticClass: "textStyle10"
  }, [_vm._v("He’d no idea what Neapolitan police procedure was like. He knew pretty well what the London police would have done, but in this city, which seemed to lurch constantly from the Middle Ages to the nineteenth century and back again, anything was possible. ‘Don’t touch anything!’ he said in English. He risked another word.")]), _vm._v(" "), _c('span', {
    staticClass: "textStyle12"
  }, [_vm._v("‘No tocca!’")]), _vm._v(" "), _c('span', {
    staticClass: "textStyle10"
  }, [_vm._v("Or did")]), _vm._v(" "), _c('span', {
    staticClass: "textStyle12"
  }, [_vm._v("toccare")]), _vm._v(" "), _c('span', {
    staticClass: "textStyle10"
  }, [_vm._v("have sexual overtones?")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle10"
  }, [_vm._v("Nobody sniggered and nobody tried to touch the corpse. The man who had come closer stepped back; the women tried to squeeze through the doorway; and behind them lights and sounds announced newcomers. The crowd parted as a uniformed policeman came through, pushing people out of his way as if they were pieces of furniture. He stopped when he saw Denton on the stairs and saluted. His eyes, however, were already on the old man’s crotch.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle10"
  }, [_vm._v("Denton came down two steps but maintained his advantage and what seemed to be his possession of the body.")]), _vm._v(" "), _c('span', {
    staticClass: "textStyle12"
  }, [_vm._v("‘Sono americano,’")]), _vm._v(" "), _c('span', {
    staticClass: "textStyle10"
  }, [_vm._v("he said.")]), _vm._v(" "), _c('span', {
    staticClass: "textStyle12"
  }, [_vm._v("‘Me chiama Denton.’")]), _vm._v(" "), _c('span', {
    staticClass: "textStyle10"
  }, [_vm._v("He recited again the sentence he’d prepared at the pension.")]), _vm._v(" "), _c('span', {
    staticClass: "textStyle12"
  }, [_vm._v("‘O")]), _vm._v(" "), _c('span', {
    staticClass: "textStyle12"
  }, [_vm._v("un appuntamento a le otto.’")]), _vm._v(" "), _c('span', {
    staticClass: "textStyle10"
  }, [_vm._v("Then he had to invent. Badly.")]), _vm._v(" "), _c('span', {
    staticClass: "textStyle12"
  }, [_vm._v("‘Con il")]), _c('span', {
    staticClass: "textStyle10"
  }, [_vm._v("—")]), _c('span', {
    staticClass: "textStyle12"
  }, [_vm._v("uomo")]), _c('span', {
    staticClass: "textStyle10"
  }, [_vm._v("—")]), _c('span', {
    staticClass: "textStyle12"
  }, [_vm._v("’")]), _vm._v(" "), _c('span', {
    staticClass: "textStyle10"
  }, [_vm._v("He gestured to the dead man below him.")]), _vm._v(" "), _c('span', {
    staticClass: "textStyle12"
  }, [_vm._v("‘Con questa uomo.’")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_39"
    }
  }), _c('span', {
    staticClass: "textStyle10"
  }, [_vm._v("The cop was middle aged and apparently not used to corpses: Naples might be a hive of petty crime and tricks and scams, but it was not big on violent death. The policeman stared at Denton, gestured with sudden ferocity at the crowd, chased them out and slammed the door, then came back and beckoned Denton down from his eminence. Putting his head close to Denton’s chest, he muttered a question whose only word Denton recognized was")]), _vm._v(" "), _c('span', {
    staticClass: "textStyle12"
  }, [_vm._v("‘cazzo’")]), _c('span', {
    staticClass: "textStyle10"
  }, [_vm._v(".")]), _vm._v(" "), _c('span', {
    staticClass: "textStyle10"
  }, [_vm._v("The")]), _vm._v(" "), _c('span', {
    staticClass: "textStyle12"
  }, [_vm._v("portiere")]), _vm._v(" "), _c('span', {
    staticClass: "textStyle10"
  }, [_vm._v("must have spilled the goriest detail as the first words out of his mouth.")]), _vm._v(" "), _c('span', {
    staticClass: "textStyle12"
  }, [_vm._v("There’s a dead man with no cock in the Palazzo Minerva!")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle10"
  }, [_vm._v("Denton’s answer was to shine his flash-light on the old man’s groin. The cop slapped his hand to his mouth and spun around, took a quick walk to the far wall and back, and presented a greyer face to Denton. Clearly,")]), _vm._v(" "), _c('span', {
    staticClass: "textStyle12"
  }, [_vm._v("cazzos")]), _c('span', {
    staticClass: "textStyle10"
  }, [_vm._v("—")]), _c('span', {
    staticClass: "textStyle12"
  }, [_vm._v("cazzi")]), _c('span', {
    staticClass: "textStyle10"
  }, [_vm._v("—were taken seriously in Naples.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle10"
  }, [_vm._v("Before Denton could stop him, and while he was struggling to find the Italian words for")]), _vm._v(" "), _c('span', {
    staticClass: "textStyle12"
  }, [_vm._v("Don’t move the body")]), _c('span', {
    staticClass: "textStyle10"
  }, [_vm._v(",")]), _vm._v(" "), _c('span', {
    staticClass: "textStyle10"
  }, [_vm._v("the cop had moved the dead man’s legs together and put the left hand over the groin, suggesting something in classical art; as if to emphasise that connection, he tried to pull the old man’s robe down, but it was caught, and so he pulled a large handkerchief, not entirely clean, from a pocket and draped it over the hand, the finished composition suggesting Lazarus or a deposition from the cross, minus the supporting players.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle12"
  }, [_vm._v("‘Obscenita publica,’")]), _vm._v(" "), _c('span', {
    staticClass: "textStyle10"
  }, [_vm._v("the cop said.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle10"
  }, [_vm._v("Denton looked him in the eye, saw only stolid propriety, shrugged.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle10"
  }, [_vm._v("The cop looked up the stairs.")]), _vm._v(" "), _c('span', {
    staticClass: "textStyle12"
  }, [_vm._v("‘A caduta.’")]), _vm._v(" "), _c('span', {
    staticClass: "textStyle10"
  }, [_vm._v("He fell. He made looping motions with his right hand.")]), _vm._v(" "), _c('span', {
    staticClass: "textStyle12"
  }, [_vm._v("‘Ba’,")]), _vm._v(" "), _c('span', {
    staticClass: "textStyle12"
  }, [_vm._v("ba’, ba’—’")]), _vm._v(" "), _c('span', {
    staticClass: "textStyle10"
  }, [_vm._v("His gestures indicated that the old man had bounced down the stairs like a ball.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle10"
  }, [_vm._v("Denton gave up.")]), _vm._v(" "), _c('span', {
    staticClass: "textStyle12"
  }, [_vm._v("‘Ascendo,’")]), _vm._v(" "), _c('span', {
    staticClass: "textStyle10"
  }, [_vm._v("he said, and without waiting for permission went back up the stairs. The cop said nothing, accepting Denton’s authority.")]), _vm._v(" "), _c('span', {
    staticClass: "textStyle12"
  }, [_vm._v("I should collect a finder’s fee.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_40"
    }
  }), _c('span', {
    staticClass: "textStyle10"
  }, [_vm._v("He walked quickly along the upper corridor, flashing his light into rooms, seeing only dust and cobwebs, ancient furniture and fallen plaster. At the far end, he found a room that was apparently the old man’s; a gas light burned there, and the source of the cooking smell sat on a gas ring—a cast-iron pot with fish soup in it. He saw no sign of actual food preparation—no knife, no board, no spices or herbs—and wondered if Fra Geraldo had been a monk who begged his food, or even bought it. But with what?")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle10"
  }, [_vm._v("Going back, he saw again the clean track down the middle of the corridor, the dirt on each side. Passing the top of the stairs, he went on, looked into more unused rooms, came to another stairway going up, blocked now with furniture that looked as if it had been purposely piled there. The old man’s attempt to keep out his ghosts?")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle10"
  }, [_vm._v("A voice shouted at him from below. He looked over the broad banister and saw more policemen and two men in civilian clothes. One of them was looking up at him, his face angry. Foreshortened by Denton’s elevation, he looked toad-like, his gut seeming to swell and drop all the way to the floor. It was Inspector Gianaculo.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle10"
  }, [_vm._v("He shouted again. He sounded angry and therefore to Denton perhaps fearful. He certainly didn’t seem to want to give Denton a medal this time. What was he afraid of? Was it because both the dead man and the man who had found him were foreigners? Would that bring in other forces the man feared—the national government? The hated")]), _vm._v(" "), _c('span', {
    staticClass: "textStyle12"
  }, [_vm._v("Carabinieri")]), _c('span', {
    staticClass: "textStyle10"
  }, [_vm._v("?")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle10"
  }, [_vm._v("Denton trotted down the stairs, stepping over the broom, then the body, which now lay stretched across the bottom tread. As he neared the bottom, he saw that another man in civilian clothes was down there as well. Tall, cadaverous, he wore evening clothes and looked furious.")]), _vm._v(" "), _c('span', {
    staticClass: "textStyle12"
  }, [_vm._v("Somebody pulled out of somewhere he’d rather be to come here. A bigwig.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle10"
  }, [_vm._v("Denton reminded Gianaculo that he didn’t understand Italian. The")]), _vm._v(" "), _c('span', {
    staticClass: "textStyle12"
  }, [_vm._v("portiere")]), _c('span', {
    staticClass: "textStyle10"
  }, [_vm._v(",")]), _vm._v(" "), _c('span', {
    staticClass: "textStyle10"
  }, [_vm._v("who was cowering next to a young policeman as if under his protection, murmured something that Denton took to mean that Denton was the man who had found the body. The young policeman slapped him. The tall one in evening clothes said something in a harsh, guttural tone, and the policeman pushed the")]), _vm._v(" "), _c('span', {
    staticClass: "textStyle12"
  }, [_vm._v("portiere")]), _vm._v(" "), _c('span', {
    staticClass: "textStyle10"
  }, [_vm._v("out the door.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_41"
    }
  }), _c('span', {
    staticClass: "textStyle10"
  }, [_vm._v("The second man in civilian clothes, who had been on his knees beside the body, the first policeman’s handkerchief now protecting his trousers from the floor, stood, his joints cracking, and groaned as he straightened his back. He bent again to pick up his hat from the corpse’s groin, where it had replaced the handkerchief, and rather fussed over putting the handkerchief back over the offending nudity. Denton took him to be a doctor. He was in his fifties, overweight, his hair perhaps black more by design than nature. He folded silver-rimmed eyeglasses, then spoke to the man in evening clothes, as if they were the only two in the place. Denton heard the word")]), _vm._v(" "), _c('span', {
    staticClass: "textStyle12"
  }, [_vm._v("magistrato")]), _c('span', {
    staticClass: "textStyle10"
  }, [_vm._v(".")]), _vm._v(" "), _c('span', {
    staticClass: "textStyle10"
  }, [_vm._v("What the hell did that mean? In London, a magistrate presided in the police court, the first level the arrested person encountered. Was it the same here? So far as Denton could tell, this magistrate swung a lot of weight: everybody deferred to him, even Gianaculo.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle10"
  }, [_vm._v("Denton got nothing from the rest of the gabble, but the pantomime was clear: the old man had broken his neck. All three men looked up the staircase. The doctor pantomimed sweeping, a sudden loss of balance, then used the same gesture the policeman had—the bouncing ball.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle12"
  }, [_vm._v("Like he was made of rubber")]), _c('span', {
    staticClass: "textStyle10"
  }, [_vm._v(",")]), _vm._v(" "), _c('span', {
    staticClass: "textStyle10"
  }, [_vm._v("Denton thought.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle10"
  }, [_vm._v("Dottor Gianaculo indicated Denton and said something. All three men looked at him.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle12"
  }, [_vm._v("‘Non parla italiano,’")]), _vm._v(" "), _c('span', {
    staticClass: "textStyle10"
  }, [_vm._v("Gianaculo said. The magistrate shook his head in disgust. They all looked severe. What sort of fool didn’t speak Italian?")])]), _vm._v(" "), _c('p', {
    staticClass: "img1"
  }, [_c('img', {
    staticClass: "scale1",
    attrs: {
      "alt": "chpt_fig_001.png",
      "src": "Images/chpt_fig_001.png"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "textStyle10"
  }, [_vm._v("We’re eating in our rooms,’ Janet said. ‘The Signora doesn’t want us endangering the morals of the other customers. It’s late now, anyway.’ A table had been set up in the sitting room, a rolling cart next to it with serving dishes under imitation-silver covers. ‘I waited for you.’ She had a glass of wine in her hand. An open bottle stood on the table—the rich red from Vesuvius. ‘I waited for you to eat, anyway.’ She laughed, more like a man’s laugh than a woman’s, a laugh he loved; she drank again, said, ‘Let’s get tiddly and commit particularly exotic kinds of sex all over the apartment.’ Her eyes were a little too wide. Rebellion against propriety excited her, made her imaginative, ironic.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_42"
    }
  }), _c('span', {
    staticClass: "textStyle10"
  }, [_vm._v("‘Eat first?’")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle10"
  }, [_vm._v("‘I suppose, but it was bad English food to start with, and now it’s cold.’ She threw herself down on a sofa. ‘How was your monk?’")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle10"
  }, [_vm._v("‘He was dead.’")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle10"
  }, [_vm._v("She stared, then broke into laughter again, then began to undo her dress. ‘To hell with eating.’")])]), _vm._v(" "), _c('p', {
    staticClass: "img1"
  }, [_c('img', {
    staticClass: "scale1",
    attrs: {
      "alt": "chpt_fig_001.png",
      "src": "Images/chpt_fig_001.png"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "textStyle10"
  }, [_vm._v("She was unabashed by her own naked body: eating in the nude or with only a Liberty shawl for cover seemed to extend her mood of rebelliousness. She was forty but had kept a fine, tight body, small breasted, lean. She was sipping the wine and eating a blood orange. He was eating boiled potatoes with cold gravy.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle10"
  }, [_vm._v("She said, ‘One of the girls at Ruth’s used to keep berry conserves so her clients could lick them off. I’ve often wondered if it’s where the expression “She’s the berries” came from. She was very popular. I couldn’t do it. I’d giggle.’")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle10"
  }, [_vm._v("He lifted the gravy boat. ‘All I can offer is cold gravy.’")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle10"
  }, [_vm._v("‘I can’t imagine you doing")]), _vm._v(" "), _c('span', {
    staticClass: "textStyle12"
  }, [_vm._v("gamahuche")]), _vm._v(" "), _c('span', {
    staticClass: "textStyle10"
  }, [_vm._v("with strawberry conserve, much less cold gravy. It’s your gravitas.’ She thought about it. ‘Gravitas with gravy?’")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle10"
  }, [_vm._v("He said, ‘We’re all low comedians when it comes to sex. But I couldn’t do it with cold gravy, no.’ He looked under another cover and found")]), _vm._v(" "), _c('span', {
    staticClass: "textStyle12"
  }, [_vm._v("zuppa inglese")]), _c('span', {
    staticClass: "textStyle10"
  }, [_vm._v(",")]), _vm._v(" "), _c('span', {
    staticClass: "textStyle10"
  }, [_vm._v("a sort of sweet custard. He dipped a finger in and held it up.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle10"
  }, [_vm._v("She put a hand over her pubis and shook her head. ‘It isn’t quite us, I think. And English soup doesn’t sound very attractive, does it?’ She ate a bit of orange and some of the juice, like watered blood, ran down from the corner of her mouth. She wiped it away with a finger. ‘Tell me about your dead man.’")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_43"
    }
  }), _c('span', {
    staticClass: "textStyle10"
  }, [_vm._v("‘Gloomy")]), _vm._v(" "), _c('span', {
    staticClass: "textStyle12"
  }, [_vm._v("palazzo")]), _c('span', {
    staticClass: "textStyle10"
  }, [_vm._v(",")]), _vm._v(" "), _c('span', {
    staticClass: "textStyle10"
  }, [_vm._v("like something out of an East End melodrama. He was lying at the bottom of the stairs. The police think he fell and broke his neck.’")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle10"
  }, [_vm._v("‘You don’t?’ She was starting on another orange, cutting a line of longitude around it with a fruit knife.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle10"
  }, [_vm._v("‘I don’t know. There was a broom on the stairs, and signs of sweeping. A man that old could have fallen—swept the landing with his back to the stairs, missed the step.’ He dribbled more of the wine into their glasses. ‘But there wasn’t much blood for somebody who’d taken that kind of fall. And none on the stairs, which I would have expected. I told the police; they shrugged. The police work wasn’t very good, in fact—a magistrate took over—that’s the way they do it here—and he made it clear he wanted to get back to his dinner.’")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle10"
  }, [_vm._v("‘Suspicious?’")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle10"
  }, [_vm._v("‘You mean, was he hiding something? I don’t think so. I think he just jumped at the obvious to get it over with—old man, broken neck, stairs. Gianaculo didn’t want to move so fast.’ Denton had pulled on his trousers and his shirt without its collar. He stretched his long legs, looked at his big, rather root-like feet. ‘The monk came to me because he was haunted, he said, ghosts trying to kill him. Well, he was loony, of course. But when somebody says something’s trying to kill him and then he turns up dead—’")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle10"
  }, [_vm._v("‘Denton the Deadeye Detective.’")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle10"
  }, [_vm._v("He grunted. ‘What really bothered the cops was that his privates were missing. Done long ago, I mean.’")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle10"
  }, [_vm._v("‘No testicles?’")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle10"
  }, [_vm._v("‘No anything.’")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle10"
  }, [_vm._v("‘Oh, dear. But that’s nothing to do with his death, is it?’")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle10"
  }, [_vm._v("‘I don’t see how.’")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle10"
  }, [_vm._v("After more wine, and as much of the cold stodge as they could stand, and the")]), _vm._v(" "), _c('span', {
    staticClass: "textStyle12"
  }, [_vm._v("zuppa inglese")]), _vm._v(" "), _c('span', {
    staticClass: "textStyle10"
  }, [_vm._v("in its proper place, and more sex, they lay together on an imitation Aubusson and she said, ‘Whatever shall we do?’")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_44"
    }
  }), _c('span', {
    staticClass: "textStyle10"
  }, [_vm._v("‘Now or after we’re thrown out?’")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle10"
  }, [_vm._v("‘After.’")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle10"
  }, [_vm._v("‘Go to a hotel. Go back to London.’ He laughed. ‘Move into a haunted house.’")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle10"
  }, [_vm._v("‘What?’ She was using his belly for a pillow; now she raised her head with difficulty and stared at him.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle10"
  }, [_vm._v("‘It’s my funny story. You didn’t give me the chance to tell you this morning. A local slicker told me he has the perfect house for us. Except that it’s haunted. A man I met after I fired Frioni. In the Galleria. The police were looking for me—because I’d beaten up the two pickpockets—and this Neapolitan flim-flam man got me out of there and over to Gambrinus’s. He’s got a haunted house for us. Kind of wonderful character. Maybe a finagler, but—’ Denton said, as if surprised, ‘I kind of liked him.’")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle10"
  }, [_vm._v("‘You’re not making much sense. Have I drunk too much wine or have you?’")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle10"
  }, [_vm._v("Denton looked at the remaining bottle, still half full. ‘Neither of us, I’d say. But he was there, as if he’d materialised from a séance—I’m going to have to go to one of those for my book—and he saved me from the coppers, and he told me this wild tale, so it’s hard to tell it sensibly. It may all be some kind of joke. He knew me. My face, my name. Apparently everybody knows me. “Texas Jack”. I knew the kids say that, but even the cops were looking for “Texas Jack”.’")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle10"
  }, [_vm._v("‘Does that make me Texas Jack’s fancy woman?’")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle10"
  }, [_vm._v("‘Mrs Jack.’")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle10"
  }, [_vm._v("‘I’d sooner you")]), _vm._v(" "), _c('span', {
    staticClass: "textStyle12"
  }, [_vm._v("gamahuched")]), _vm._v(" "), _c('span', {
    staticClass: "textStyle10"
  }, [_vm._v("me with the cold gravy. I wonder whatever happened to that girl who used the preserves. I wonder that a lot—what happened to girls I knew. All middle aged and fat or dead now. It’s shocking what happens to whores. But no more shocking than what happens to all women.’ She hooked her right hand behind his neck. She was looking at the ceiling. ‘I feel bad about Lucy. I worry about her. That mother.’")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_45"
    }
  }), _c('span', {
    staticClass: "textStyle10"
  }, [_vm._v("‘Seeing yourself?’")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle10"
  }, [_vm._v("‘Because my mother sold me, you mean? Yes, maybe it’s that. But mine did it for, she thought, my own good—money, position, a husband—not that it turned it out that way. Mrs Newcombe wants a son-in-law with a title she can show off in Rochester, New York; it isn’t for Lucy at all. She’s only seventeen; she’ll be married off and she won’t know what men are or what a cheat marriage is or—’ She moved impatiently against his chest. ‘At least I suppose she won’t end up in St Ives.’ Janet had spent four years in the St Ives Prison for the Criminally Insane. Her husband had put her there because she was ‘defiant’.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_46"
    }
  }), _c('span', {
    staticClass: "textStyle10"
  }, [_vm._v("She stood, snatched the Liberty shawl from the sofa and draped it over her shoulders. Holding out a hand, she said, ‘Sleep in my room tonight.’ He got up, pleased. She opened her mouth to say something that he hoped would please him even more, but what she said was, ‘Poor Lucy.’ She took his hand, shook her head without looking at him and said, ‘A night in a haunted house sounds a wonderful idea. It will clear our brains.’")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6af5a720","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/Chapter03.vue
// module id = 75
// module chunks = 0